// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"ea58173f","453":"a552f9a7"}[chunkId] + ".chunk.js";
};